import { Highlighter } from "lucide-react";
import { PageHeader } from "@/components/cast/Common";
import { VerseCollection } from "@/components/cast/Highlights";

export default function MyVerses() {
  return (
    <div>
      <PageHeader metaphor="Shore" label="My verses" title="Verses you've held onto." subtitle="Every verse you highlight in a story or study lands here, in the Bible version you read it in." />
      <div className="mb-6 flex items-center gap-2 text-sm text-slate-500"><Highlighter className="h-4 w-4 text-amber-600" />Tap Highlight on any verse to add it.</div>
      <VerseCollection />
    </div>
  );
}
